import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../../theme';
import { Text } from '../../common/Text/Text';
import { ErrorInfoIcon } from '../../../../icons';

interface GiftProcessingBannerProps {}

const StyledDiv = styled.div`
  gap: 8px;
  padding: 16px;
  display: flex;
  font-size: 14px;
  border-radius: 16px;
  margin-bottom: 24px;
  border: 2px solid ${colors.borderComponentInfo};
  svg {
    width: 24px;
    height: 24px;
  }
  .banner-message {
    text-align: left;
  }
`;

const GiftProcessingBanner: React.FC<GiftProcessingBannerProps> = () => {
  return (
    <StyledDiv>
      <div className="error-info-icon">
        <ErrorInfoIcon color="borderComponentInfo" />
      </div>
      <div className="banner-message">
        <Text
          weight="extraBold"
          variant="small"
        >
          Gift Processing
        </Text>
        <Text
          weight="light"
          variant="small"
        >
          This may take a few hours. We'll email you if there’s an issue.
        </Text>
      </div>
    </StyledDiv>
  );
};

export default GiftProcessingBanner;
